/* global $ */
import React, {Component} from 'react';

import VideoIntro from './VideoIntro';

class VideoIntroContainer extends Component {
    componentDidMount() {
        console.log('Event:VideoIntro:mount');
        this.initialiseVideoPlayer()

    }

    componentDidUpdate() {
        console.log('Event:VideoIntro:update');
        if(!$('#bgndVideo').is('.mb_YTPlayer')) {
            console.log('ReINit: YTPlayer');
            this.initialiseVideoPlayer()
        }
    }

    componentWillUnmount() {
        console.log('Event:VideoIntro:leaving the building');
        $('#bgndVideo').YTPPlayerDestroy()
    }

    initialiseVideoPlayer() {
        $('#bgndVideo').YTPlayer()
    }

    render() {
        return(
            <VideoIntro/>
        )
    }
}

export default VideoIntroContainer;



// WEBPACK FOOTER //
// ./src/pages/home/components/videoIntro/VideoIntroContainer.jsx